import { createNanoEvents } from "nanoevents";

const _emitter = createNanoEvents();

/**
 * Event emitter class using nanoevents.
 * Provides methods to subscribe to and emit events.
 */
class Emitter {
    /**
     * Registers a listener for the specified event.
     * The listener will be called with the arguments passed to `emit` for that event.
     * @param name - The name of the event to listen for.
     * @param listener - The function to call when the event is emitted.
     * @returns A function that, when called, unsubscribes the listener from the event.
     */
    on = (name: string, listener: Function): Function => {
        return _emitter.on(name, listener as any);
    }

    /**
     * Emits an event with the specified name and arguments.
     * All listeners registered for that event will be called with the provided arguments.
     * @param name - The name of the event to emit.
     * @param args - The arguments to pass to the listeners.
     */
    emit = (name: string, ...args: any): void => {
        _emitter.emit.apply(_emitter, [name, ...args]);
    }
}

/**
 * Singleton instance of the Emitter class.
 * Use this to subscribe to and emit events throughout the application.
 */
const singleton = new Emitter();

export default singleton;